$(document).ready(function(){

    const fixedBtn = $('.fixed-contact');
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) { // Wenn 100 Pixel gescrolled wurde
            fixedBtn.addClass('active');
        } else {
            fixedBtn.removeClass('active');
        }
    });
});
